/* eslint-disable react-hooks/exhaustive-deps */
import React, { useCallback, useMemo } from 'react';

import ChartHolder from '../ChartHolder';
import toEmptyConfig from '../EmptyConfig';
import { DEFAULT_GROUP } from '../../constants/common';
import { isDataEmpty } from '../Common';
import { RETENTION_CHART_BY_DATE_VIEWS, retentionViews } from '../../constants/retention';
import { toComplexRetentionByDateChartData, toComplexRetentionChartData } from './DataConverter';
import {
  toComplexRetentionByDateColumnConfig,
  toComplexRetentionColumnConfig,
} from './ColumnChart';
import { toComplexRetentionByDateLineConfig, toComplexRetentionLineConfig } from './LineChart';

const getConfig = (view) => {
  switch (view) {
    case retentionViews.CHART:
      return toComplexRetentionLineConfig;
    case retentionViews.COLUMN_CHART:
      return toComplexRetentionColumnConfig;
    case retentionViews.CHART_BY_DATE:
      return toComplexRetentionByDateLineConfig;
    case retentionViews.COLUMN_CHART_BY_DATE:
      return toComplexRetentionByDateColumnConfig;

    default:
      return toEmptyConfig;
  }
};

const Chart = ({
  result,
  executeTime,
  executedQuery,
  options,
  timezone,
  group = DEFAULT_GROUP,
  height,
  setChart,
  fromDashboard,
}) => {
  const data = useMemo(() => {
    if (!result) {
      return [];
    }

    return RETENTION_CHART_BY_DATE_VIEWS.includes(options.view)
      ? toComplexRetentionByDateChartData(result, executedQuery, timezone)
      : toComplexRetentionChartData(result, executedQuery, timezone);
  }, [options.view, executeTime]);

  const toConfig = useCallback(
    (dataParam) => {
      const toChartConfig = isDataEmpty(dataParam) ? toEmptyConfig : getConfig(options.view);

      return toChartConfig(dataParam, { ...options, timezone, group }, fromDashboard);
    },
    [options.view, executeTime]
  );

  return (
    <div style={{ height: height || 400, width: '100%' }}>
      <ChartHolder data={data} toConfig={toConfig} setChart={setChart} />
    </div>
  );
};

export default Chart;
